/**
 * Date Utility Functions
 * Shared date formatting utilities
 */

/**
 * Format date with time
 *
 * @param {string|Date} dateString - Date to format
 * @returns {string} Formatted date string
 */
export const formatDate = (dateString) => {
    if (!dateString) return 'Not set';
    try {
        const date = new Date(dateString);
        return date.toLocaleString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    } catch {
        return 'Invalid date';
    }
};

/**
 * Format duration string
 *
 * @param {string} duration - Duration string (e.g., "1d", "24h", "30d")
 * @returns {string} Human-readable duration
 */
export const formatDuration = (duration) => {
    if (!duration || duration === 'N/A') return 'Not set';
    if (duration === '1d') return 'Daily (24h)';
    if (duration === '7d') return 'Weekly (7d)';
    if (duration === '24h') return 'Daily (24h)';
    if (duration === '30d') return 'Monthly (30d)';
    if (duration === '365d') return 'Yearly (365d)';
    return duration;
};
